import Axios from '../../library/Axios'

export const EventViewAction = (id: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'EVENT_VIEW_REQUEST' })

        const { data } = await new Axios().get(`/get/event/${id}`)

        dispatch({ type: 'EVENT_VIEW_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'EVENT_VIEW_ERROR' })
    } finally {
        // dispatch({ type: 'EVENT_VIEW_RESET' })
    }
}

export const EventRegViewAction = (id: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'EVENT_REG_VIEW_REQUEST' })

        const { data } = await new Axios().get(`/get/event/register/${id}`)

        dispatch({ type: 'EVENT_REG_VIEW_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'EVENT_REG_VIEW_ERROR' })
    } finally {
        // dispatch({ type: 'EVENT_VIEW_RESET' })
    }
}

export const RegisterEventPostAction = (eventId: string, name: string, family: string, gender: string, national_code: string, martial: string, father: string, mobileEmergency: string, telephoneEmergency: string, description: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'REGISTER_EVENT_POST_REQUEST' })

        const { data } = await new Axios().post(`/post/event/reserve/${eventId}`, {
            name: name,
            family: family,
            father: father,
            gender: gender,
            martial: martial,
            national_code: national_code,
            telephone_emergency: telephoneEmergency,
            mobile_emergency: mobileEmergency,
            description: description
        })

        dispatch({ type: 'REGISTER_EVENT_POST_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'REGISTER_EVENT_POST_ERROR' })
    } finally {
        dispatch({ type: 'REGISTER_EVENT_POST_RESET' })
    }
}